<header class="header-2">
  <div class="branding">
    <span class="title">{{ 'Linien verwalten' | mrTranslate }}</span>
  </div>
  <div class="header-actions">
    <a href="javascript://" class="nav-link nav-icon">
      <cds-icon shape="times" (click)="close()"></cds-icon>
    </a>
  </div>
</header>

<div class="overlay-inner-wrapper">
  <div id="objekttpyWrapper">
    <clr-tabs>
      <clr-tab>
        <button clrTabLink (click)="tabChange('user')">
          {{ 'Linien' | mrTranslate }}
        </button>
        @if (activeTabs.user) {
          <clr-tab-content>
            <div class="clr-row padding-10-t">
              <div class="clr-col-12">
                <div class="btn-group btn-primary btn-icon">
                  <button class="btn btn-success" (click)="newitem()">
                    <cds-icon shape="file" />
                    <span class="clr-icon-title">Add</span>
                  </button>
                  <button class="btn btn-danger" [disabled]="selid == 0" (click)="deletitem()">
                    <cds-icon shape="times" />
                    <span class="clr-icon-title">Delete</span>
                  </button>
                </div>
                @if (objekte?.rows?.length) {
                  <div class="limit-height">
                    <clr-datagrid
                      style="padding-top: 0px"
                      class="datagrid-compact"
                      [clrDgRowSelection]="true"
                      [clrDgSelectionType]="'single'"
                      [clrDgSelected]="[selobjekt]"
                      (clrDgSelectedChange)="selobjekt = $event[0]; selectionObjektChanged($event[0])">
                      <clr-dg-column>{{ 'Symbol' | mrTranslate | titlecase }}</clr-dg-column>
                      <clr-dg-column>{{ 'Nummer' | mrTranslate | titlecase }}</clr-dg-column>
                      <clr-dg-column>{{ 'Ort' | mrTranslate | titlecase }}</clr-dg-column>
                      <clr-dg-column>{{ 'über' | mrTranslate | titlecase }}</clr-dg-column>
                      <clr-dg-column>{{ 'Belastung' | mrTranslate | titlecase }}</clr-dg-column>
                      <clr-dg-column>{{ 'Benutzer' | mrTranslate | titlecase }}</clr-dg-column>
                      <clr-dg-column>{{ 'Zeitstempel' | mrTranslate | titlecase }}</clr-dg-column>
                      <clr-dg-row *clrDgItems="let item of objekte.rows" [clrDgItem]="item">
                        <clr-dg-cell style="color: #000">
                          <cds-icon class="grid-icon" [shape]="item['icon']" size="28"></cds-icon>
                        </clr-dg-cell>
                        <clr-dg-cell>{{ item.Nummer | tablePrettyPrint }}</clr-dg-cell>
                        <clr-dg-cell>{{ item.Ort | tablePrettyPrint }}</clr-dg-cell>
                        <clr-dg-cell>{{ item.Weg | tablePrettyPrint }}</clr-dg-cell>
                        <clr-dg-cell>{{ item.Belastung | tablePrettyPrint }}</clr-dg-cell>
                        <clr-dg-cell>{{ item.UserName | tablePrettyPrint }}</clr-dg-cell>
                        <clr-dg-cell>{{ item.Status | tablePrettyPrint }}</clr-dg-cell>
                      </clr-dg-row>
                      <ng-template clrIfDetail let-detail (clrIfDetailChange)="onDetailOpen($event)">
                        <clr-dg-detail>
                          <clr-dg-detail-header>{{ detail['Nummer'] }}</clr-dg-detail-header>
                          <clr-dg-detail-body>
                            <br />
                            <div class="clr-row">
                              <div class="clr-col-3">
                                {{ 'Symbol' | mrTranslate }}
                              </div>
                              <div class="clr-col-3">
                                <div>
                                  <img [src]="getSVGImageUrl(svgFile)" style="margin-left: -1px" />
                                </div>
                              </div>
                            </div>
                            <br />
                            <div class="clr-row">
                              <div class="clr-col-3">
                                {{ 'Nummer' | mrTranslate }}
                              </div>
                              <div class="clr-col-9">
                                <input
                                  type="text"
                                  id="basic"
                                  #bezfield
                                  class="clr-input"
                                  value="{{ detail['Nummer'] }}"
                                  (change)="onChange($event.target.value, 'nummer')"
                                  #_nummer />
                              </div>
                            </div>
                            <br />
                            <div class="clr-row">
                              <div class="clr-col-3">
                                {{ 'Ort' | mrTranslate }}
                              </div>
                              <div class="clr-col-9">
                                <input
                                  type="text"
                                  id="basic"
                                  #bezfield
                                  class="clr-input"
                                  value="{{ detail['Ort'] }}"
                                  #_ort />
                              </div>
                            </div>
                            <br />
                            <div class="clr-row">
                              <div class="clr-col-3">
                                {{ 'über' | mrTranslate }}
                              </div>
                              <div class="clr-col-9">
                                <input
                                  type="text"
                                  id="basic"
                                  #bezfield
                                  class="clr-input"
                                  value="{{ detail['Weg'] }}"
                                  #_weg />
                              </div>
                            </div>
                            <br />
                            <div class="clr-row">
                              <div class="clr-col-3">
                                {{ 'Belastung' | mrTranslate }}
                              </div>
                              <div class="clr-col-9">
                                <input
                                  type="number"
                                  id="basic"
                                  #bezfield
                                  class="clr-input"
                                  value="{{ detail['Belastung'] }}"
                                  #_belastung />
                              </div>
                            </div>
                            <br />
                            <div class="clr-row">
                              <div class="clr-col-3">
                                {{ 'Schriftfarbe' | mrTranslate }}
                              </div>
                              <div class="clr-col-9">
                                <input
                                  id="forecolor"
                                  type="color"
                                  class="cursor-pointer"
                                  value="{{ detail['ForeColor'] }}"
                                  (change)="onChange($event.target.value, 'forecolor')"
                                  #_forecolor />
                              </div>
                            </div>
                            <br />
                            <div class="clr-row">
                              <div class="clr-col-3">
                                {{ 'Hintergrundfarbe' | mrTranslate }}
                              </div>
                              <div class="clr-col-9">
                                <input
                                  id="fillcolor"
                                  type="color"
                                  class="cursor-pointer"
                                  value="{{ detail['BackColor'] }}"
                                  (change)="onChange($event.target.value, 'fillcolor')"
                                  #_fillcolor />
                              </div>
                            </div>
                            <div class="clr-row">
                              <div class="clr-col-3">
                                <button class="btn btn-primary" type="submit" (click)="saveItems(detail.ID)">
                                  {{ 'Speichern' | mrTranslate }}
                                </button>
                              </div>
                            </div>
                          </clr-dg-detail-body>
                        </clr-dg-detail>
                      </ng-template>
                      <clr-dg-footer>{{ objekte.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                    </clr-datagrid>
                  </div>
                }
              </div>
            </div>
          </clr-tab-content>
        }
      </clr-tab>

      @if (objekte != undefined) {
        <clr-tab>
          <button clrTabLink (click)="tabChange('belegung')">
            {{ 'Linienbelegung' | mrTranslate }}
          </button>
          @if (activeTabs.belegung) {
            <clr-tab-content>
              <div class="clr-row" id="groupSelectionRow" [ngClass]="{ enlarged: !_selectedLinienForObject }">
                <div class="clr-col-12 text-center">
                  <clr-select-container style="display: inline-block">
                    <select clrSelect [(ngModel)]="selectedLinienForObject" [disabled]="!stammobjekteorginal">
                      <option [value]="undefined" disabled selected>
                        {{ 'Linie auswählen' | mrTranslate }}
                      </option>
                      @for (line of objekteorginal; track line) {
                        <option [ngValue]="+line.ID">
                          {{ line.Nummer + ' - ' + line.Ort }}
                        </option>
                      }
                    </select>
                  </clr-select-container>
                </div>
                @if (_selectedLinienForObject) {
                  <div id="objectSelectionWrapper" class="clr-row">
                    <div class="clr-col" style="max-width: calc(calc(100% - 8.3333333333%) / 2)">
                      <div class="limit-height">
                        @if (stammobjekte?.columns?.length) {
                          <clr-datagrid
                            class="datagrid-compact"
                            [clrDgSelectionType]="'multi'"
                            [clrDgItemsIdentityFn]="row => row?.OSTAMMID"
                            [(clrDgSelected)]="selectedStammList"
                            [clrDgRowSelection]="true">
                            @for (column of stammobjekte.columns; track column) {
                              <clr-dg-column [clrDgField]="column.id">
                                <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                                  {{ column.id | mrTranslate | titlecase }}
                                </ng-container>
                              </clr-dg-column>
                            }
                            <ng-template
                              clrVirtualScroll
                              let-row
                              [clrVirtualRowsOf]="stammobjekte.rows"
                              [clrVirtualRowsTrackBy]="(_, row) => row?.OSTAMMID">
                              <clr-dg-row [clrDgItem]="row">
                                @for (cell of stammobjekte.columns; track cell) {
                                  <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                                }
                              </clr-dg-row>
                            </ng-template>
                            <clr-dg-footer>{{ stammobjekte.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                          </clr-datagrid>
                        }
                      </div>
                    </div>
                    <div id="objectControl" class="clr-col-1">
                      <a
                        href="javascript:void(0);"
                        [ngClass]="{ disabled: selectedStammList.length == 0 }"
                        (click)="executeToAdd()">
                        <cds-icon shape="circle-arrow" direction="right" class="big-icon" style="color: green" />
                      </a>
                      <a
                        href="javascript:void(0);"
                        [ngClass]="{ disabled: selectedLinieList.length == 0 }"
                        (click)="executeToRemove()">
                        <cds-icon
                          shape="circle-arrow"
                          direction="left"
                          class="big-icon"
                          style="color: red"
                          solid="true" />
                      </a>
                    </div>
                    <div class="clr-col" style="max-width: calc(calc(100% - 8.3333333333%) / 2)">
                      <div class="limit-height">
                        @if (groupObjects?.columns?.length) {
                          <clr-datagrid
                            class="datagrid-compact"
                            [clrDgSelectionType]="'multi'"
                            [clrDgItemsIdentityFn]="row => row?.OSTAMMID"
                            [(clrDgSelected)]="selectedLinieList"
                            [clrDgRowSelection]="true">
                            @for (column of groupObjects.columns; track column) {
                              <clr-dg-column [clrDgField]="column.id">
                                <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                                  {{ column.id | mrTranslate | titlecase }}
                                </ng-container>
                              </clr-dg-column>
                            }
                            <ng-template
                              clrVirtualScroll
                              let-row
                              [clrVirtualRowsOf]="groupObjects.rows"
                              [clrVirtualRowsTrackBy]="(_, row) => row?.OSTAMMID">
                              <clr-dg-row [clrDgItem]="row">
                                @for (cell of groupObjects.columns; track cell) {
                                  <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                                }
                              </clr-dg-row>
                            </ng-template>
                            <clr-dg-footer>{{ groupObjects.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                          </clr-datagrid>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </clr-tab-content>
          }
        </clr-tab>
        <clr-tab>
          <button clrTabLink (click)="tabChange('anlagenklassen')">
            {{ 'Anlagenklassen' | mrTranslate }}
          </button>
          @if (activeTabs.anlagenklassen) {
            <clr-tab-content>
              <div class="clr-row padding-10-t">
                <div class="clr-col-12">
                  <div class="btn-group btn-primary btn-icon">
                    <button class="btn" (click)="calcAK()">
                      <cds-icon shape="calculator" />
                      <span class="clr-icon-title">{{ 'Anlagenklassen berechnen' | mrTranslate }}</span>
                    </button>
                  </div>
                </div>
              </div>
              @if (anlagenklassen?.columns) {
                <clr-datagrid style="padding-top: 0px" class="datagrid-compact">
                  <clr-dg-column>{{ 'Bezeichnung' | mrTranslate | titlecase }}</clr-dg-column>
                  <clr-dg-column>{{ 'min' | mrTranslate | titlecase }}</clr-dg-column>
                  <clr-dg-column>{{ 'max' | mrTranslate | titlecase }}</clr-dg-column>
                  <clr-dg-column>{{ 'Intevall' | mrTranslate | titlecase }}</clr-dg-column>
                  <clr-dg-column>{{ 'Benutzer' | mrTranslate | titlecase }}</clr-dg-column>
                  <clr-dg-column>{{ 'Zeitstempel' | mrTranslate | titlecase }}</clr-dg-column>
                  <clr-dg-row *clrDgItems="let item of anlagenklassen.rows" [clrDgItem]="item">
                    <clr-dg-cell>{{ item.Bezeichnung | tablePrettyPrint }}</clr-dg-cell>
                    <clr-dg-cell>{{ item.min | tablePrettyPrint }}</clr-dg-cell>
                    <clr-dg-cell>{{ item.max | tablePrettyPrint }}</clr-dg-cell>
                    <clr-dg-cell>{{ item.Intervall | tablePrettyPrint }}</clr-dg-cell>
                    <clr-dg-cell>{{ item.UserName | tablePrettyPrint }}</clr-dg-cell>
                    <clr-dg-cell>{{ item.Status | tablePrettyPrint }}</clr-dg-cell>
                  </clr-dg-row>
                  <ng-template clrIfDetail let-detail (clrIfDetailChange)="onAKDetailOpen($event)">
                    <clr-dg-detail>
                      <clr-dg-detail-header>
                        {{ 'Anlagenklasse' | mrTranslate | titlecase }}: {{ detail['Bezeichnung'] }}
                      </clr-dg-detail-header>
                      <clr-dg-detail-body>
                        <div class="clr-row">
                          <div class="clr-col-1"></div>
                          <div class="clr-col-3">{{ 'Belastung' | mrTranslate | titlecase }}:</div>
                        </div>
                        <div class="clr-row">
                          <div class="clr-col-1">
                            {{ 'min' | mrTranslate }}
                          </div>
                          <div class="clr-col-3">
                            <input
                              type="number"
                              id="basic"
                              #bezfield
                              class="clr-input"
                              value="{{ detail['min'] }}"
                              #_akmin />
                          </div>
                        </div>
                        <br />
                        <div class="clr-row">
                          <div class="clr-col-1">
                            {{ 'max' | mrTranslate }}
                          </div>
                          <div class="clr-col-3">
                            <input
                              type="number"
                              id="basic"
                              #bezfield
                              class="clr-input"
                              value="{{ detail['max'] }}"
                              #_akmax />
                          </div>
                        </div>
                        <br />
                        <div class="clr-row">
                          <div class="clr-col-1"></div>
                          <div class="clr-col-3">{{ 'Inspektion' | mrTranslate | titlecase }}:</div>
                        </div>
                        <div class="clr-row">
                          <div class="clr-col-1">
                            {{ 'Intervall' | mrTranslate }}
                          </div>
                          <div class="clr-col-3">
                            <input
                              type="number"
                              id="basic"
                              #bezfield
                              class="clr-input"
                              value="{{ detail['Intervall'] }}"
                              #_akintervall />
                          </div>
                        </div>
                        <br />
                        <div class="clr-row">
                          <div class="clr-col-1"></div>
                          <div class="clr-col-3">
                            <button class="btn btn-primary" type="submit" (click)="saveAKItems(detail.ID)">
                              {{ 'Speichern' | mrTranslate }}
                            </button>
                          </div>
                        </div>
                      </clr-dg-detail-body>
                    </clr-dg-detail>
                  </ng-template>
                </clr-datagrid>
              }
            </clr-tab-content>
          }
        </clr-tab>
      }
    </clr-tabs>
  </div>
</div>

<clr-modal [(clrModalOpen)]="isModalVisible" [clrModalClosable]="true">
  <h3 class="modal-title">{{ modaltitel | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="vertical" [formGroup]="linieGroup">
      <div class="clr-row">
        <div class="clr-col-3">
          {{ 'Symbol' | mrTranslate }}
        </div>
        <div class="clr-col-3">
          @if (svgFile !== undefined) {
            <div>
              <img [src]="getSVGImageUrl(svgFile)" style="margin-left: -1px" />
            </div>
          }
        </div>
      </div>
      <br />
      <div class="clr-row">
        <div class="clr-col-3">
          {{ 'Nummer' | mrTranslate }}
        </div>
        <div class="clr-col-9">
          <input
            type="text"
            id="basic"
            #bezfield
            class="clr-input"
            formControlName="nummer"
            (change)="onChange($event.target.value, 'nummer')" />
        </div>
      </div>
      <br />
      <div class="clr-row">
        <div class="clr-col-3">
          {{ 'Ort' | mrTranslate }}
        </div>
        <div class="clr-col-9">
          <input type="text" id="basic" #bezfield class="clr-input" formControlName="ort" />
        </div>
      </div>
      <br />
      <div class="clr-row">
        <div class="clr-col-3">
          {{ 'über' | mrTranslate }}
        </div>
        <div class="clr-col-9">
          <input type="text" id="basic" #bezfield class="clr-input" formControlName="weg" />
        </div>
      </div>
      <br />
      <div class="clr-row">
        <div class="clr-col-3">
          {{ 'Belastung' | mrTranslate }}
        </div>
        <div class="clr-col-9">
          <input type="number" id="basic" #bezfield class="clr-input" formControlName="belastung" />
        </div>
      </div>
      <br />
      <div class="clr-row">
        <div class="clr-col-3">
          {{ 'Schriftfarbe' | mrTranslate }}
        </div>
        <div class="clr-col-9">
          <input
            id="forecolor"
            type="color"
            class="cursor-pointer"
            [ngStyle]="{ 'background-color': linieGroup.value.forecolor }"
            formControlName="forecolor"
            (change)="onChange($event.target.value, 'forecolor')" />
        </div>
      </div>
      <br />
      <div class="clr-row">
        <div class="clr-col-3">
          {{ 'Hintergrundfarbe' | mrTranslate }}
        </div>
        <div class="clr-col-9">
          <input
            id="fillcolor"
            type="color"
            class="cursor-pointer"
            [ngStyle]="{ 'background-color': linieGroup.value.fillcolor }"
            formControlName="fillcolor"
            (change)="onChange($event.target.value, 'fillcolor')" />
        </div>
      </div>
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="addLinie()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="isModalVisible = false">{{ 'Abbrechen' | mrTranslate }}</button>
  </div>
</clr-modal>
